export const CUI_COPY = {
  header: 'CONTROLLED:  Documentation in this system can contain CUI',
  footer: 'CUI',
  designation:
    'Controlled by: Authentise | Category: PROCURE/FEDCON | ' +
    'Distribution: FEDCON | POC: Andre Wegner (andre@authentise.com)',
};

const headerClass = `
  shrink-0
  bg-[linear-gradient(90deg,rgba(249,115,22,0.05),#2B303B_25%,#2B303B_75%,rgba(249,115,22,0.05))]
  border-b-2 border-orange-500/80
  shadow-[inset_0_-1px_0_rgba(255,255,255,0.03),0_2px_10px_rgba(0,0,0,0.25)]
`;

const footerClass = `
  shrink-0
  bg-[linear-gradient(90deg,rgba(249,115,22,0.04),#292E38_25%,#292E38_75%,rgba(249,115,22,0.04))]
  border-t-2 border-orange-500/70
  shadow-[inset_0_1px_0_rgba(255,255,255,0.03),0_-2px_10px_rgba(0,0,0,0.22)]
`;

export const CuiHeaderBanner = () => (
  <div
    className={`
      ${headerClass}
      flex h-8 items-center justify-center px-3
    `}
  >
    <span
      className="
        w-full
        text-center
        text-[10px]
        font-extrabold
        uppercase
        tracking-[0.3em]
        text-orange-300
        drop-shadow-[0_0_6px_rgba(251,146,60,0.25)]
      "
    >
      {CUI_COPY.header}
    </span>
  </div>
);

export const CuiFooter = () => (
  <footer className={`${footerClass} px-4 py-2 sm:px-5`}>
    <div
      className="
        mx-auto
        flex
        max-w-screen-2xl
        flex-col
        items-center
        justify-center
        gap-1.5
        sm:flex-row
        sm:gap-3
      "
    >
      <span
        className="
          shrink-0
          rounded-md
          border
          border-orange-400/60
          bg-orange-500/20
          px-2.5
          py-0.5
          text-[10px]
          font-extrabold
          uppercase
          tracking-[0.18em]
          text-orange-200
          shadow-[0_0_8px_rgba(249,115,22,0.08)]
        "
      >
        {CUI_COPY.footer}
      </span>

      <span
        className="
          text-center
          text-[10px]
          font-medium
          leading-4
          text-slate-200
          sm:text-xs
        "
      >
        {CUI_COPY.designation}
      </span>
    </div>
  </footer>
);
